import { Link } from "react-router-dom";
import SectionHeader from "../components/SectionHeader";
import { SERVICES } from "../data/site";
import { motion } from "framer-motion";
import {
  ArrowRight, Code, Server, Users, ShoppingBag, ShieldCheck, Cloud, Smartphone, Palette, Layout,
  Compass, GraduationCap, MessageSquare, CreditCard, LayoutTemplate, FileBadge, Cctv,
  PackageSearch, Cable, BatteryCharging, ListChecks,
} from "lucide-react";

const ICONS = {
  Layout, Code, Server, Users, ShoppingBag, ShieldCheck, Cloud, Smartphone, Palette,
  Compass, GraduationCap, MessageSquare, CreditCard, LayoutTemplate, FileBadge, Cctv,
  PackageSearch, Cable, BatteryCharging, ListChecks,
};

export default function Services() {
  return (
    <section className="container-st pt-16 pb-24">
      <SectionHeader
        eyebrow="Services"
        title="Our services at a glance."
        subtitle="Amcblast Solutions Limited provides full-cycle services – from planning and design to development, integration, deployment and support – across Web, Mobile & Social applications and supporting infrastructure."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className={`${s.bg} rounded-3xl p-8 hover:-translate-y-1 transition`}
              data-testid={`services-card-${s.slug}`}
            >
              <div className="h-12 w-12 rounded-2xl bg-white grid place-items-center shadow-sm">
                {Icon && <Icon className="w-6 h-6 text-blue-600" />}
              </div>
              <h3 className="mt-5 text-xl font-semibold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-700">{s.short}</p>
              <Link to={`/services/${s.slug}`} className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-blue-700">
                Read more <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
